import React from "react";
import ForgotPasswordForm from "./ForgotPasswordForm";

const ForgotPassword = ()=>{

    return (
        <ForgotPasswordForm />
    )
}
export default ForgotPassword;